module.exports = __webpack_public_path__ + "assets/img/banner1.cf8d792f.png";